import React from 'react';
import { ChevronDown } from './icons';
interface CollapsibleSectionProps { title: string; icon?: React.ReactNode; defaultOpen?: boolean; children: React.ReactNode; }
const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({title, icon, defaultOpen = true, children}) => (
  <details open={defaultOpen} className="ui-panel group">
    <summary className="flex items-center justify-between p-4 md:p-6 cursor-pointer"><h2 className="text-lg font-semibold text-ink flex items-center gap-3">{icon && <span className="text-brand-600">{icon}</span>}{title}</h2><ChevronDown size={20} className="group-open:rotate-180 transition-transform" /></summary>
    <div className="px-4 pb-4 md:px-6 md:pb-6">{children}</div>
  </details>
);
export default CollapsibleSection;
